import Vue from "vue";
import Vuex from 'vuex';
Vue.use(Vuex);//添加依赖

window.addEventListener("offline", function (e) {

  // Message.error({
  //   message: '网络链接已断开!'
  // });
  alert('网络链接已断开!');

})

window.addEventListener("online", function (e) {
  // Message.success({
  //   message: '网络链接已链接!'
  // });
  alert('网络链接已链接!');
})



// WEBPACK FOOTER //
// ./src/utils/network.js